export const clients = [
  '192.168.103.153',
  'accel-corp-test.vulog.center',
  'aimo-corp-test.vulog.center',
  'aimo-corp.vulog.center',
  'amag-corp-poc.vulog.center',
  'arval-corp-poc.vulog.center',
  'arvalqa-corp-poc.vulog.center',
  'arvalqa-corp-qa.vulog.center',
  'autom-corp-test.vulog.center',
  'autom-corp.vulog.center',
  'business.wigomobility.com',
  'businessfo-dev.vulog.center',
  'cityhop-corp-poc.vulog.center',
  'corpo-corp-poc.vulog.center',
  'demo-ff-corp.vulog.center',
  'demo-ff-corp.vulogcn.com',
  'demo-franchise-corp.vulog.center',
  'demo-sched-corp.vulog.center',
  'demosta-corp-test.vulog.center',
  'easymove-corp-test.vulog.center',
  'easymove-corp.vulog.net',
  'ego-corp-test.vulog.center',
  'ego-corp.vulog.center',
  'eloop-corp-test.vulog.center',
  'eloop-corp.vulog.center',
  'emov-corp-test.vulog.center',
  'enuu-corp-test.vulog.center',
  'enuu-corp.vulog.center',
  'epilot-corp-poc.vulog.center',
  'evie-corp-test.vulog.center',
  'evie-corp.vulog.center',
  'evme-corp-poc.vulog.center',
  'evo-corp-test.vulog.center',
  'evo-corp.vulog.center',
  'f2m-corp-test.vulog.center',
  'ffgwen-corp-qa.vulog.center',
  'fr-corp-dev.vulog.center',
  'fr-corp-qa.vulog.center',
  'getaround-corp-test.vulog.center',
  'gig-corp-poc.vulog.center',
  'hourcar-corp-test.vulog.center',
  'hourcar-corp.vulog.center',
  'hyundai-corp-poc.vulog.center',
  'innova-corp-test.vulog.center',
  'kintoca-corp-poc.vulog.center',
  'kintoeu-corp-test.vulog.center',
  'kintoeu-corp.vulog.center',
  'kintojo-corp-test.vulog.center',
  'kintojo-corp.vulog.center',
  'kintopoc-corp-test.vulog.center',
  'ladefense-corp-poc.vulog.center',
  'ladefense-corp-test.vulog.center',
  'leongo-corp-test.vulog.center',
  'leongo-corp.vulog.center',
  'liberty-corp-migrate.vulog.center',
  'liberty-corp-test.vulog.center',
  'marguerite-corp-test.vulog.center',
  'marguerite-corp.vulog.center',
  'mevo-corp-test.vulog.center',
  'mevo-corp.vulog.center',
  'mitta-corp-test.vulog.center',
  'mitta-corp.vulog.center',
  'mobee-corp-test.vulog.center',
  'mobee-corp.vulog.center',
  'mobile-corp-qa.vulog.center',
  'mobizz-corp-test.vulog.center',
  'mobizz-corp.vulog.center',
  'mol-corp-test.vulog.center',
  'mol-corp.vulog.center',
  'multi-corp-dev.vulog.center',
  'multi-corp-qa.vulog.center',
  'nrvcs-corp-test.vulog.center',
  'nrvcs-corp.vulog.center',
  'originenergy-corp-test.vulog.center',
  'originenergy-corp.vulog.center',
  'otto-corp-poc.vulog.center',
  'park-corp-poc.vulog.center',
  'pfsde-corp-test.vulog.net',
  'pfsde-corp.vulog.net',
  'pon-corp-poc.vulog.center',
  'poppy-corp-test.vulog.center',
  'poppy-corp.vulog.center',
  'porsche-corp-poc.vulog.center',
  'porsche-corp-test.vulog.center',
  'porsche-corp.vulog.center',
  'qasb-corp-qa.vulog.center',
  'qasb-franchise-corp-qa.vulog.center',
  'racv-corp-qa.vulog.center',
  'rulla-corp-test.vulog.center',
  'rulla-corp.vulog.center',
  'sbgwen-corp-qa.vulog.center',
  'sbmulti-corp-dev.vulog.center',
  'shaary-corp-test.vulog.center',
  'slk-corp-test.vulog.center',
  'sterne-corp-poc.vulog.center',
  'stmcar-corp-test.vulog.center',
  'troopy-corp-test.vulog.center',
  'volkswagen-corp-poc.vulog.center',
  'vulogoa-corp-qa.vulog.center',
  'vulogqa-corp-qa.vulog.center',
  'vw-corp-test.vulog.center',
  'vw-corp.vulog.center',
  'vy-corp-test.vulog.center',
  'wible-corp-test.vulog.center',
  'wible-corp.vulog.center',
  'wigo-corp.vulog.center',
  'zity-corp-poc.vulog.center',
];
